import LeaveType from "./LeaveType/Routes";
import LeaveAppval from "./LeaveApproval/Routes";
import SettingMO from "./MO/Routes";
import SettingLRC from "./LRC/Routes";
import LeaveTypeDetail from "./LeaveTypeDetail/Routes";

export default [...SettingMO, ...SettingLRC, ...LeaveType, ...LeaveTypeDetail, ...LeaveAppval];
